module.exports = __webpack_public_path__ + "static/img/107_TO8_1797.c5ff4df.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/107_TO8_1797.jpg
// module id = zjLY
// module chunks = 0